export const fr = {
    words: {
        'day': 'jour',
        'days': 'jours',
    },
    general: {
        cancel: 'Annuler',
    },
    calendar: {
        days: {
            sun: 'Dim',
            mon: 'Lun',
            tue: 'Mar',
            wed: 'Mer',
            thu: 'Jeu',
            fri: 'Ven',
            sat: 'Sam'
        },
        months: {
            jan: 'Janvier',
            feb: 'Février',
            mar: 'Mars',
            apr: 'Avril',
            may: 'Mai',
            jun: 'Juin',
            jul: 'Juillet',
            aug: 'Août',
            sep: 'Septembre',
            oct: 'Octobre',
            nov: 'Novembre',
            dec: 'Décembre'
        },
        short_months: {
            jan: 'Jan',
            feb: 'Fév',
            mar: 'Mar',
            apr: 'Avr',
            may: 'Mai',
            jun: 'Jui',
            jul: 'Jul',
            aug: 'Aoû',
            sep: 'Sep',
            oct: 'Oct',
            nov: 'Nov',
            dec: 'Déc'
        },
        today: 'Aujourd\'hui',
        tomorrow: 'Demain',
        yesterday: 'Hier',
        week: 'Semaine',
        month: 'Mois',
        year: 'Année'
    },
    cities: {
        browse: 'Rechercher par destination',
        bologna: 'Bologne',
        firenze: 'Florence',
        cagliari: 'Cagliari',
        bari: 'Bari',
        milano: 'Milan',
        roma: 'Rome',
        palermo: 'Palermo',
        catania: 'Catania',
        links: {
            bologna: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-bologne/',
            firenze: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-florence/',
            cagliari: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-cagliari/',
            bari: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-bari/',
            milano: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-milan/',
            roma: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-rome/',
            palermo: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-palermo/',
            catania: 'https://scopri.auting.it/fr/autopartage-entre-particuliers-catania/',
        }
    },
    components: {
        search_bar: {
            cta: 'Rechercher',
            select_date: 'Sélectionner la date',
            select_dates: 'Sélectionner les dates',
            time: 'Heure',
            time_label: 'Heure',
            select_start_datetime: 'Sélectionner la date et l\'heure de début',
            select_end_datetime: 'Sélectionner la date et l\'heure de fin',
            booking_warning: 'Les réservations doivent commencer au moins 2 heures après l\'heure actuelle',
            cancel: 'Annuler',
            confirm: 'Confirmer',
            confirm_dates: 'Confirmer les Dates',
            start_date: 'Date de début',
            end_date: 'Date de fin',
            start_time_label: 'Heure de début',
            end_time_label: 'Heure de fin',
            end_before_start_error: 'La date de fin ne peut pas être antérieure à la date de début !',
            coordinates_error: 'Erreur lors de la récupération des coordonnées. Essayez avec une autre adresse.'
        },
        nav: {
            how_it_works: 'Comment ça marche',
            faq: 'FAQ',
            publish_your_car: 'Publiez votre voiture',
            sign_in: 'Se connecter',
            get_started: 'Commencer',
            profile: 'Profil',
            earnings: 'Vos gains',
            cars: 'Vos voitures',
            trips_driver: 'Vos voyages',
            trips_owner: 'Vos voyages avec vos voitures',
            documents: 'Documents',
            change_language: 'Changer de langue',
            menu: 'Menu',
            open_menu: 'Ouvrir le menu',
            logout: 'Se déconnecter',
            push_notifications: 'Notifications push',
            push_denied_hint: 'Notifications bloquées : activez-les dans les paramètres du navigateur.',
            push_error: 'Impossible de mettre à jour les notifications. Réessayez.',
            push_open: 'Ouvrir',
        },
        footer: {
            branding_section: {
                claim: 'Aussi pratique que la voiture de votre voisin',
                description: 'Auting est la première plateforme italienne de location de voitures entre particuliers. Le service vous permet de réserver une voiture auprès d\'un propriétaire privé pour un ou plusieurs jours consécutifs. Voyagez partout en Italie, l\'esprit tranquille grâce à un partenaire d\'assurance solide comme Reale Mutua.',
            },
            links_section: {
                learn_more: 'En savoir plus',
                how_it_works: 'Comment ça marche',
                publish_your_car: 'Publiez votre voiture',
                faq: 'FAQ',
                blog: 'Blog',
                product: 'Produit',
                download_ios: 'Télécharger sur iOS',
                download_android: 'Télécharger sur Android',
                legal: 'Legal',
                limitations: 'Limitations',
                privacy_policy: 'Politique de confidentialité',
                terms_of_service: 'Conditions de service',
                cookie_policy: 'Politique de cookies',
                copyright: '© Yago s.r.l. 2018 - tous droits réservés - P. IVA 03488191200',
                support_email: 'support@auting.it',
                partner: 'Partenaires',
            }
        },
        faq: {
            title_first_line: 'Vos questions,',
            title_second_line: 'nos réponses',
            cta: 'Lire toutes les FAQ',
            owner: {
                accordions: {
                    '1': {
                        question: 'Comment puis-je publier ma voiture?',
                        answer: 'Le processus est très rapide et peut être effectué:\n\n - sur le site Web d\'Auting en cliquant sur le bouton "Publiez votre voiture" dans le coin supérieur droit de la page d\'accueil ;\n - via l\'application Auting, disponible dans les magasins Android et iOS, en cliquant sur l\'icône de la voiture sur la page d\'accueil de l\'application.',
                    },
                    '2': {
                        question: 'Comment fonctionne le ramassage et la restitution d\'une voiture?',
                        answer: 'Le ramassage de la voiture n\'a lieu qu\'après le paiement de la réservation. Après le paiement, le numéro de téléphone du Owner sera visible dans les détails du voyage. Les lieux de ramassage et de restitution de la voiture peuvent être convenus entre le conducteur et le Owner pendant le processus de réservation.',
                    },
                    '3': {
                        question: 'Qui fixe le prix de ma voiture?',
                        answer: 'Vous êtes libre de fixer le prix minimum souhaité pour votre voiture et de le mettre à jour à tout moment. Vous pouvez également fixer un prix pour les kilomètres supplémentaires qui peuvent être achetés par le conducteur pendant le processus de réservation.'
                    },
                    '4': {
                        question: 'Qui paie le ravitaillement de la voiture?',
                        answer: 'Nous vous suggérons de livrer la voiture avec un plein de carburant. Le conducteur est responsable de retourner la voiture avec le même niveau de carburant qui était présent lors de la prise en charge de la voiture et qui était indiqué sur la liste de contrôle.',
                    },
                    '5': {
                        question: 'Combien de kilomètres le conducteur peut-il parcourir?',
                        answer: 'Pour chaque jour de réservation, le conducteur dispose de 150 km avec un maximum de 500 km par semaine. Au moment de la réservation, le conducteur peut acheter des kilomètres supplémentaires. Le prix des kilomètres supplémentaires est fixé par le Owner dans la section prix du profil de la voiture.'
                    },
                },
            },
            driver: {
                accordions: {
                    '1': {
                        question: 'Comment réserver une voiture?',
                        answer: 'Vous pouvez trouver une voiture soit depuis la page d\'accueil de ce site, soit sur l\'application Auting en saisissant la ville et les dates que vous recherchez.\nVous verrez les voitures disponibles dans la ville et aux dates choisies sur une carte et dans une liste avec le prix et le modèle de la voiture.\nVous pourrez soumettre plusieurs demandes de réservation en même temps.\nLes Owners pourront accepter votre demande, la refuser ou la laisser expirer.\nUne fois votre demande acceptée, vous pourrez procéder au paiement.',
                    },
                    '2': {
                        question: 'Y a-t-il des exigences pour les conducteurs pour réserver une voiture?',
                        answer: 'Au moment de la demande de réservation, le conducteur doit avoir au moins 21 ans et doit posséder un permis de conduire valide en Italie depuis au moins 3 ans.\nLe conducteur doit posséder les documents suivants:\n\n - un document d\'identité valide (carte d\'identité ou passeport)\n - un permis de conduire valide en Italie (la date de première délivrance ou le dernier renouvellement du permis doit être présent sur le document et doit être antérieur à 3 ans)\n - si le permis a été délivré dans un pays en dehors de l\'Union européenne, le conducteur doit présenter, en plus du permis national, un permis de conduire international (IDP)',
                    },
                    '3': {
                        question: 'Je suis-je assuré contre tous les risques?',
                        answer: 'Pendant la durée de la réservation, la voiture bénéficie d\'une couverture contre les dommages, le vol, le bris de glace et le vandalisme de Reale Mutua Assicurazioni, avec une assistance routière premium 24/7 et un dépôt de garantie de 0 €.\n\nAu moment de la réservation, il est possible de choisir le niveau d\'exposition au risque de dommages ou de vol et d\'atteindre jusqu\'à 0 € de responsabilité.\n\nLe tarif de base inclut déjà une limite de responsabilité faible.'
                    },
                    '4': {
                        question: 'Comment fonctionne le ramassage et la restitution d\'une voiture?',
                        answer: 'Le ramassage de la voiture n\'a lieu qu\'après le paiement de la réservation.\nAprès le paiement, le numéro de téléphone du Owner sera visible dans les détails du voyage. Les lieux de ramassage et de restitution de la voiture peuvent être convenus entre le conducteur et le Owner pendant le processus de réservation.',
                    },
                    '5': {
                        question: 'Quelle est la différence entre Auting et les sociétés de location?',
                        answer: 'Auting est un service écologique qui permet l\'utilisation de voitures qui resteraient inutilisées.\nCela permet également de fournir un service plus convivial, basé sur une connexion directe avec le Owner.\nEnfin, le prix d\'Auting est moins cher qu\'un service de location de voiture et comprend:\n - une assistance routière premium 24/7\n - un dépôt de garantie de 0 €\n - un seuil de responsabilité limité (à sélectionner au moment de la réservation).'
                    },
                },
            }
        },
        blog: {
            title: 'Auting Blog',
            cta: 'Lire tous les articles',
        },
        owner: {
            top_subheadline: 'Vous avez une voiture?',
            headline: 'Faites-la gagner!',
            cta: 'Publiez votre voiture',
            img_alt: 'Illustration du Owner',
        },
        mobile_app: {
            subtitle: 'Utilisez Auting sur votre téléphone',
            title: 'Commencez votre voyage',
            title_accent: 'd\'un seul toucher 🎯',
        }
    },
    common: {
        back: 'Retour',
        any: 'Tout',
        reset: 'Réinitialiser',
        apply: 'Appliquer',
        retry: 'Réessayer',
        yes: 'Oui',
        no: 'Non',
        per_day: 'jour'
    },
    errors: {
        generic: 'Une erreur est survenue. Veuillez réessayer plus tard.',
        reservation: {
            Numero_telefono_mancante_o_non_verificato_prenotazione_veicolo_non_consentita: 'Vous ne pouvez pas effectuer de réservation car vous n\'avez pas encore vérifié votre numéro de téléphone. Allez dans votre profil pour vérifier votre numéro de téléphone.',
            Prenotazione_veicolo_non_consentita_Specificare_nome_e_cognome: 'Vous ne pouvez pas effectuer de réservation car votre profil ne contient pas votre nom complet. Allez dans votre profil pour ajouter cette information.',
            Data_inizio_prenotazione_mancante: 'Pour réserver un véhicule, vous devez spécifier une date de début valide pour la réservation.',
            Data_fine_prenotazione_mancante: 'Pour réserver un véhicule, vous devez spécifier une date de fin valide pour la réservation.',
            Data_in_formato_non_corretto: 'La date fournie n\'est pas au format correct. Utilisez le format AAAA-MM-JJ HH:MM.',
            Id_del_veicolo_mancante: 'Pour réserver un véhicule, vous devez sélectionner un véhicule valide.',
            Messaggio_di_richiesta_prenotazione_mancante: 'Pour réserver un véhicule, vous devez fournir un message de demande de réservation au propriétaire.',
            Lunghezza_del_messaggio_superiore_al_limite_consentito: 'La longueur du message de demande de réservation dépasse la limite autorisée de 500 caractères.',
            Data_di_inizio_noleggio_successiva_alla_data_di_fine_noleggio: 'La date de début du voyage ne peut pas être postérieure à la date de fin.',
            La_data_di_inizio_noleggio_non_può_coincidere_con_la_data_di_fine_noleggio: 'La date de début du voyage ne peut pas être la même que la date de fin.',
            Periodo_della_prenotazione_superiore_al_massimo_consentito: 'La période de réservation dépasse la limite maximale autorisée de 30 jours.',
            Prenotazione_non_consentita_data_di_inizio_viaggio_troppo_ravvicinata: 'La réservation n\'est pas autorisée : la date de début du voyage est trop proche. La réservation doit commencer au moins 2 heures après l\'heure actuelle.',
            Veicolo_gia_prenotato_per_il_periodo_indicato: 'Le véhicule est déjà réservé pour la période spécifiée.',
            Prezzo_veicolo_non_ancora_impostato_prenotazione_veicolo_non_consentita: 'Le véhicule ne peut pas être réservé car le prix n\'a pas encore été fixé par le propriétaire.',
            Prezzo_veicolo_non_ancora_impostato_pubblicazione_veicolo_non_consentita: 'Le véhicule ne peut pas être publié car le prix n\'a pas encore été fixé par le propriétaire.',
            Prenotazione_non_consentita_lutente_che_richiede_la_prenotazione_è_il_proprietario_del_veicolo: 'Vous ne pouvez pas réserver votre propre véhicule.',
            Veicolo_non_trovato: 'Le véhicule sélectionné n\'existe pas.',
            Veicolo_di_annata_superiore_al_limite_consentito_non_prenotabile: 'Le véhicule sélectionné est plus ancien que la limite autorisée et ne peut pas être réservé.',
            Prezzo_della_prenotazione_fuori_range: 'Le prix de la réservation est en dehors de la plage autorisée.'
        }
    },
    routes: {
        login: {
            title: 'Connectez-vous à votre compte',
            subtitle: 'Veuillez entrer vos identifiants pour continuer.',
            else: 'autre',
            dont_have_account: 'Vous n\'avez pas de compte?',
            register: 'S\'inscrire',
            enter_email: 'Entrez votre email',
            enter_password: 'Entrez votre mot de passe',
            forgot_password: 'Mot de passe oublié?',
            logging_in: 'Connexion en cours',
            login: 'Se connecter',
        },
        register: {
            title: 'Inscrivez-vous à Auting',
            subtitle: 'Veuillez remplir le formulaire pour créer votre compte.',
            first_name: 'Prénom',
            your_first_name: 'Votre prénom',
            last_name: 'Nom de famille',
            your_last_name: 'Votre nom de famille',
            else: 'autre',
            do_have_an_account: 'Vous avez déjà un compte?',
            login: 'Se connecter',
            register: 'S\'inscrire',
            registering: 'Inscription en cours',
            enter_email: 'Entrez votre email',
            enter_password: 'Créez un mot de passe',
            forgot_password: 'Mot de passe oublié?',
            success_message_in_dialog: 'Inscription réussie! Vérifiez votre email pour confirmer votre compte, puis connectez-vous.',
        },
        forgot_password: {
            title: 'Récupération du mot de passe',
            description: 'Réinitialisez votre mot de passe pour retrouver l\'accès à votre compte.',
            header_title: 'Mot de passe oublié?',
            header_subtitle: 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
            email_placeholder: 'votre@email.com',
            send_reset_link: 'Envoyer le lien de réinitialisation',
            sending: 'Envoi en cours...',
            enter_email: 'Entrez votre email',
            invalid_email: 'Entrez un email valide',
            reset_error: 'Erreur lors de l\'envoi de l\'email de réinitialisation. Veuillez réessayer.',
            back_to_login: '← Retour à la connexion',
            email_sent: 'Email envoyé!',
            email_sent_message: 'Nous avons envoyé un lien de réinitialisation du mot de passe à <strong>{email}</strong>, vérifiez votre boîte de réception et suivez les instructions pour réinitialiser votre mot de passe.',
            go_to_login: 'Aller à la connexion',
        },
        home: {
            title: 'Auting : location entre particuliers en Itaile',
            description: 'Choisissez la voiture qui vous convient, réservez-la et partez. Des milliers de voitures privées vous attendent dans toute l\'Italie. Oubliez la location de voiture, oubliez le covoiturage, découvrez la location entre particuliers d\'Auting !',
            keywords: 'publication de voiture, partage de voiture, location de voiture entre particuliers, location de voiture, Auting',
            header: {
                title: "Trouvez, réservez, partez",
                description: "Réservez une voiture auprès d'un particulier dans 150 villes d'Italie",
                project_insured_by: "Projet assuré par",
            },
            search: {
                placeholder: "Recherchez la voiture parfaite",
                button: "Rechercher",
            },
            steps_title: 'Une voiture pour les vacances, pour le travail, pour déménager... suivez simplement ces quelques étapes :',
            steps: {
                '1': 'Trouvez la voiture parfaite pour vous',
                '2': 'Échanger avec le Owner',
                '3': 'Payez la réservation',
                '4': 'Récupérez la voiture et partez!',
            },
            pricing: {
                subtitle: 'Qu\'est-ce qui est mieux qu\'un service de location de voiture ?',
                title_accent: 'Sûre, Abordable, Confortable.',
                description: 'La voiture de nos Owners est facile à atteindre et vous offre des voyages tranquilles et confortables.',
                cols: {
                    auting: {
                        description: 'Les prix de base incluent déjà les options PREMIUM :',
                        items: {
                            '1': '✅ 0€ de dépôt de garantie',
                            '2': '✅ Faible responsabilité en cas de dommages ou de vol',
                            '3': '✅ Assistance routière premium 24/7',
                            '4': '✅ Communication et prise en charge faciles',
                        },
                        alt: {
                            sub_description: 'De plus :',
                            sub_items: {
                                '1': '✅ Avec seulement 6€/jour, vous bénéficiez d\'une franchise 0€ en cas de dommages ou de vol*'
                            }
                        }
                    },
                    other: {
                        title: 'Autres services',
                        description: 'Les prix initiaux cachent :',
                        items: {
                            '1': '❌ 1500 - 3500 € de dépôt de garantie',
                            '2': '❌ Haute responsabilité jusqu\'à 3500 €',
                            '3': '❌ Assistance de base',
                            '4': '❌ Longues files d\'attente au comptoir',
                        },
                        alt: {
                            sub_separator: 'ou bien :',
                            sub_description: '❌ jusqu\'à 50€/jour en plus du prix de location de base pour :',
                            sub_items: {
                                '1': '- 0€ de franchise en cas de dommages ou de vol',
                                '2': '- dépôt de garantie 0€',
                                '3': '- assurance premium'
                            }
                        }
                    }
                }
            },
            auting_values: {
                title: 'et bien plus encore :',
                cols: {
                    '1': {
                        headline: 'Une voiture à la portée de tous',
                        text: 'Voitures situées en ville, près des gares et des aéroports. Ou juste au coin de la rue !',
                    },
                    '2': {
                        headline: 'Not just a service, a real community',
                        text: '+65.000 utilisateurs actifs parmi les Owners et les conducteurs',
                    }
                },
                cta: 'En savoir plus',
            },
            cities: {
                cta: 'Recherchez une voiture dans 150 villes',
            },
            cars_grid: {
                title: "Les meilleures voitures à Milan",
                loading: 'Chargement des voitures...',
                no_vehicles: 'Aucune voiture trouvée pour cette recherche',
                error: 'Erreur de chargement : ',
            }
        },
        driver: {
            title: 'Auting: comment ça marche ?',
            description: 'Découvrez comment fonctionne l\'autopartage entre particuliers d\'Auting. Trouvez des voitures de Owners privés autour de vous, envoyez une demande et voyagez partout en Italie de 1 jour jusqu\'à 30 jours consécutifs. Aussi facile qu\'avantageux.',
            header: {
                title: 'Comment fonctionne Auting ?',
            },
            how_it_works: {
                title: '',
                cols: {
                    '1': {
                        headline: 'Trouvez la voiture parfaite pour vous',
                        subheadline: 'Entrez où et quand vous avez besoin d\'une voiture, consultez l\'offre et lisez les avis des utilisateurs précédents.',
                    },
                    '2': {
                        headline: 'Discutez avec le Owner',
                        subheadline: 'Envoyez des demandes aux Owners et discutez directement avec eux pour organiser la prise en charge de la voiture.',
                    },
                    '3': {
                        headline: 'Payez la réservation',
                        subheadline: 'Paiement sécurisé par carte de crédit via la plateforme.',
                    },
                    '4': {
                        headline: 'Récupérez la voiture et conduisez !',
                        subheadline: 'Le jour de la réservation, rencontrez le Owner pour la livraison ou déverrouillez le véhicule avec l\'application.',
                    }
                }
            },
            advantages: {
                title: 'Pourquoi les prix d\'Auting sont-ils si avantageux ?',
                cols: {
                    '1': {
                        items: {
                            '1': 'Responsabilité limitée en cas de dommages ou de vol',
                            '2': 'Couverture d\'assurance premium',
                            '3': 'Assistance routière premium 24/7',
                            '4': 'Annulation gratuite',
                            '5': 'Dépôt de garantie 0€',
                            '6': 'Communication facile pour la prise en charge',
                            '7': 'ET EN PLUS',
                            '8': 'Avec seulement 6 €/jour, vous avez 0€ de franchise en cas de dommages ou de vol*'
                        }
                    },
                    '2': {
                        title: 'Prix d\'une location de voiture classique',
                        items: {
                            '1': 'Responsabilité jusqu\'à 3500€',
                            '2': 'Pas d\'assistance routière premium',
                            '3': 'Dépôt de garantie de 1500 à 3500 euros',
                            '4': 'L\'annulation n\'est pas toujours incluse ou peut entraîner une pénalité financière',
                            '5': 'Jusqu\'à 50€/jour en plus du prix de base de la location pour :\n\n - 0€ de responsabilité en cas de dommages/vol\n\n - dépôt de garantie 0€\n\n - assurance premium',
                            '6': 'Longue attente au comptoir de location',
                        }
                    },
                }
            },
            service: {
                title: 'Un service intelligent et pratique',
                cols: {
                    '1': {
                        headline: 'Un service de proximité',
                        subheadline: 'Les voitures sont situées autour de vous. Géolocalisez et atteignez la voiture la plus proche pour partir vers votre destination.',
                    },
                    '2': {
                        '1': {
                            headline: 'Check-in rapide!',
                            subheadline: 'Oubliez les files d\'attente au comptoir de location pour récupérer votre voiture. Prenez votre voiture en seulement 5 minutes !',
                        },
                        '2': {
                            headline: 'Un service étendu',
                            subheadline: 'Les voitures d\'Auting sont partout en Italie, dans les rues des centres-villes, près des gares ou des aéroports.',
                        },
                    }
                }
            }
        },
        owner: {
            title: 'Auting : partagez votre voiture',
            description: 'Devenez Owner d\'Auting et gagnez de l\'argent en partageant votre voiture. Enregistrez votre voiture gratuitement en quelques étapes simples. Partagez-la quand vous voulez, au prix que vous souhaitez.',
            earn: {
                title: 'Votre voiture pourrait rapporter {currency} {earnings}',
                slider: '{days} {unit}',
                estimated_earnings: 'Votre estimation de gain pour {days} jours de partage par mois',
                loading: 'Chargement de vos gains potentiels...',
                loading_car_data: 'Récupération des dernières données sur la voiture...',
                loading_error: 'Erreur de chargement des données',
                cta: 'Publiez votre voiture',
                img_alt: 'Illustration de voiture',
                select_car_type: 'Sélectionnez le type de voiture',
                select_car_year: 'Sélectionnez l\'année de la voiture'
            },
            metrics: {
                title: 'Rejoignez des milliers de Owners sur Auting.',
                title_accent: 'C\'est facile!',
                cols: {
                    '1': {
                        headline: '+8.000',
                        subheadline: 'voitures enregistrées',
                    },
                    '2': {
                        headline: '+65.000',
                        subheadline: 'utilisateurs actifs',
                    },
                    '3': {
                        headline: '24/7',
                        subheadline: 'Assistance premium',
                    },
                    '4': {
                        headline: 'Covered by',
                        subheadline: '',
                        image: true,
                    }
                }
            },
            how_to_publish: {
                title: 'Publiez votre voiture.<br/>Partagez. Gagnez.',
                title_accent: 'C\'est facile! Ça l\'est vraiment.',
                cols: {
                    '1': {
                        headline: 'Inscription',
                        subheadline: 'Créez votre compte et enregistrez votre voiture.',
                    },
                    '2': {
                        headline: 'Publiez',
                        subheadline: 'Téléchargez des photos et une description de la voiture. Précisez son prix et sa disponibilité',
                    },
                    '3': {
                        headline: 'Partagez',
                        subheadline: 'Recevez des demandes, acceptez-les ou refusez-les. Contactez directement le Driver!',
                    },
                    '4': {
                        headline: 'Gagnez',
                        subheadline: 'Recevez des gains directement sur votre compte à la fin du trajet.',
                    }
                }
            },
            advantages: {
                title: 'Pourquoi Auting',
                title_accent: 'est-il si unique ?',
                cols: {
                    '1': {
                        headline: 'Auting est un service reconnu et sûr',
                        subheadline: 'Soutenu par des partenaires de confiance tels que Cassa Depositi Prestiti et Reale Mutua Assicurazioni.',
                    },
                    '2': {
                        headline: 'Protéger votre voiture est notre priorité',
                        subheadline: 'L\'assurance et l\'assistance routière premium 24/7 sont toujours incluses dans le service.',
                    },
                    '3': {
                        headline: 'Nous vous soutenons dans le partage',
                        subheadline: 'Le service client, le courtage avec les conducteurs et la vérification des utilisateurs sont inclus dans le service.',
                    },
                    '4': {
                        headline: 'Nous contribuons à votre succès',
                        subheadline: 'Notre site web et notre application travaillent pour rendre votre voiture plus visible, tant pour vos voisins que pour les voyageurs italiens ou étrangers.',
                    },
                    '5': {
                        headline: 'Transactions faciles et sécurisées',
                        subheadline: 'Nous collectons l\'argent du conducteur avant le voyage. À la fin du voyage, vous recevez de notre part un virement directement sur votre compte.',
                    }
                }
            },
            ways_of_sharing: {
                title_first_line: '2 façons',
                title_second_line: 'de partager votre voiture',
                cols: {
                    '1': {
                        headline: 'Rencontre avec le Owner',
                        subheadline: 'Rencontrez le Owner au lieu convenu. Remplissez la liste de contrôle et photographiez l\'état de la voiture. Échangez les clés.',
                    },
                    '2': {
                        headline: 'Auting Connect',
                        subheadline: 'Disponible uniquement dans la ville de Milan. Avec le dispositif Auting Connect, vous pouvez partager la voiture à distance via l\'application.',
                        label_accent: 'Gagnez plus !',
                    },
                },
            },
            protections: {
                top_subheadline_accent: '”Est-ce que c\'est sûr ? Il s\'agit de ma voiture!”',
                title: 'Protéger votre voiture est notre première priorité',
                cta: 'En savoir plus',
                insured_by: 'Projet assuré par',
                cols: {
                    1: {
                        top_subheadline_accent: 'Pas de soucis',
                        headline: 'Vous êtes protégé ✅',
                    },
                    2: {
                        headline: 'Assistance routière premium 24/7',
                        subheadline: 'Remorquage du véhicule jusqu\'à l\'atelier le plus proche ou celui choisi.',
                    },
                }
            },
            super_owner: {
                title: 'Plus vous partagez, plus vous gagnez',
                text: 'Découvrez le programme SuperOwner.',
                cta: 'En savoir plus',
            },

        },
        car: {
            instant_booking: 'Acceptation instantanée',
            instant_booking_hint: 'Ce véhicule accepte les demandes automatiquement : vous recevez la confirmation immédiatement.',
            page_title: 'Location de voiture',
            car: 'Voiture',
            owner: 'Owner',
            new: 'Nouveau',
            not_specified: 'Non spécifié',
            location_not_available: 'Position non disponible',
            discount_example: 'Remise 3 jours, 7€',
            free_cancellation_until: 'Annulation gratuite jusqu\'à',
            hours_before: 'heures avant',
            free_cancellation_24h: 'Annulation gratuite jusqu\'à 24h avant',
            km_included: 'km inclus',
            rca_base_included: 'RCA Base incluse',
            not_included: 'Non inclus',
            to_be_chosen: 'À choisir',
            vehicle_not_available: 'Véhicule non disponible pour les dates sélectionnées',
            please_select_dates: 'Sélectionnez les dates de réservation',
            vehicle_info_missing: 'Les informations du véhicule sont manquantes',
            seats: 'places',
            doors: 'portes',
            trips: 'voyages',
            insurance: 'Assurance',
            comforts: 'Conforts',
            no_comforts_listed: 'Aucun confort spécifique répertorié',
            conditions: 'Conditions de réservation',
            vehicle_details: 'Détails du véhicule',
            keyless: 'Ouverture sans clés',
            verified: 'Vérifié',
            mileage: 'Kilométrage',
            loading_owner_info: 'Chargement info Owner...',
            failed_load_owner_info: 'Impossible de charger les info Owner',
            trips_as_owner: 'voyages comme Owner',
            super_owner: 'Super Owner',
            pro: 'Professionnel',
            about_vehicle: 'À propos de ce véhicule',
            new_vehicle: 'Nouveau véhicule',
            about_vehicle_description: '',
            how_does_it_work: 'Comment ça marche ?',
            auting_connect_modal: {
                title: 'Comment fonctionne Auting Connect',
                content: 'Avec Auting Connect, vous ouvrirez et fermerez la voiture uniquement via l\'application Auting.\nAvant d\'envoyer la demande de réservation, le conducteur doit impérativement vérifier la disponibilité de l\'application dans son pays.\nL\'enregistrement et le départ de la réservation se feront uniquement via l\'application Auting. La position de la voiture sera visible 30 minutes avant le début de la réservation. (Remarque : vous ne pourrez pas commencer votre voyage avant l\'heure de départ exacte de votre réservation). Assurez-vous que le GPS et les données mobiles sont activés sur votre smartphone. Vous recevrez par e-mail le code PIN nécessaire pour ouvrir la voiture, dans l\'objet « Code PIN requis pour accéder à la voiture ».\nLorsque vous serez à côté de la voiture, vous suivrez la procédure d\'enregistrement dans l\'application. Vous trouverez les clés dans la boîte à gants de la voiture.\nPendant le trajet, vous utiliserez les clés de la voiture pour l\'ouvrir et la fermer.\nÀ la fin du trajet, vous devez restituer la voiture à moins de 500 mètres du point d\'enregistrement et effectuer la procédure de départ dans l\'application.',
                faq_link: 'FAQ',
                how_it_works_link: 'Comment ça marche',
                close: 'FERMER'
            },
            pro_user_modal: {
                title: 'Utilisateur Professionnel',
                content: '<strong>L\'utilisateur Owner est appelé "professionnel" lorsqu\'il prévoit au voyage une couverture d\'assurance de base de son propre partenaire d\'assurance, inclus dans le prix payé en ligne.</strong> Cette couverture d\'assurance est basée sur la responsabilité civile et peut être assortie d\'autres couvertures supplémentaires (par exemple, assurance tous risques, assistance routière, autres). <strong>Auting ne fournit pas la couverture d\'assurance de notre partenaire Reale Mutua Assicurazioni.</strong><br><br>Dans le cas où le Owner est un utilisateur professionnel, ce contrat est valide exclusivement jusqu\'au Check-in. Pour l\'enregistrement, le voyage, le départ et le traitement après le voyage, s\'appliquent les conditions contractuelles de l\'utilisateur professionnel.<br><br><strong>Lors du Check-in, l\'utilisateur Professionnel peut demander au Driver de signer d\'autres accords à ceux d\'Auting et de se conformer à d\'autres exigences.</strong> <strong>Par exemple, il peut: demander un dépôt de garantie sur la carte de crédit;</strong> Offrir une couverture d\'assurance optionnelle et des services supplémentaires ; Demander un supplément si le Driver souhaite livrer dans un endroit autre que celui rapporté; avoir des politiques différentes sur la gestion des amendes; Fournir des voitures autres que celles de l\'annonce mais du même groupe économique.<br><br>En effectuant une réservation et par la suite le paiement en ligne de ce véhicule, le Driver accepte que le Owner puisse demander d\'autres conditions et services contractuels au début et fin du voyage.',
                close: 'FERMER'
            },
            year: 'Année',
            brand: 'Marque',
            model: 'Modèle',
            type: 'Type',
            fuel: 'Carburant',
            gears: 'Transmission',
            doors_number: 'N. portes',
            unknown: 'Inconnu',
            reviews: 'avis',
            trips_completed: 'voyages complétés',
            vehicle_new_no_reviews: 'Ce véhicule est nouveau et n\'a pas encore d\'avis.',
            be_first_to_review: 'Soyez le premier à évaluer cette voiture !',
            system_review: 'Avis système',
            no_comment_provided: 'Aucun commentaire fourni',
            guidelines: 'Directives',
            faqs: 'FAQ',
            read_more: 'Lire plus',
            dates: 'Dates',
            change: 'Changer',
            pickup_return: 'Prise en charge et retour',
            trip_saving: 'Économie voyage',
            cancellation: 'Annulation',
            distance_included: 'Distance incluse',
            request_more: 'Demander plus',
            checking_availability: 'Vérification de la disponibilité...',
            continue_booking: 'Continuer avec la réservation',
            no_charge_note: 'Vous ne recevrez aucun débit à ce stade',
            vehicle_not_available_short: 'Véhicule non disponible',
            vehicle_not_available_dates: 'Ce véhicule n\'est pas disponible pour les dates sélectionnées.',
            days: 'jours',
            discount: 'de réduction',
            additional_km: 'Km supplémentaires',
            service_cost: 'Coût du service',
            security_deposit: 'Dépôt de garantie',
            limited_liability: 'Responsabilité limitée',
            enter_promo_code: 'Entrer le code promo',
            apply: 'Appliquer',
            coupon: 'Coupon',
            total: 'Total',
            loading_car_details: 'Chargement des détails de la voiture...',
            edit_booking_dates: 'Modifier les dates de réservation',
            select_additional_km: 'Sélectionner les kilomètres supplémentaires',
            continue: 'Continuer',
            not_available: 'Non disponible',
            booking_summary: 'Résumé de la réservation',
            transmission: {
                manual: 'Manuelle',
                automatic: 'Automatique'
            },
            modify_booking_dates: 'Modifier les dates de réservation',
            select_additional_kilometers: 'Sélectionner les kilomètres supplémentaires',
            km_description: 'Choisissez le nombre de kilomètres supplémentaires dont vous avez besoin pour votre voyage :',
            no_charge_at_this_stage: 'Vous ne recevrez aucun débit à ce stade. Le paiement sera traité après l\'approbation du Owner.',
            be_first_reviewer: 'Soyez le premier à évaluer cette voiture !',
            fuel_types: {
                benzina: 'Essence',
                diesel: 'Diesel',
                gpl: 'GPL',
                metano: 'Méthane',
                elettrica: 'Électrique',
                ibrida: 'Hybride'
            },
            categories: {
                berlina: 'Berline',
                city_car: 'Citadine',
                fuoristrada: 'Tout-terrain',
                minivan: 'Monospace',
                station_wagon: 'Break',
                suv: 'SUV',
                crossover: 'Crossover',
                furgone: 'Fourgon'
            },
            comforts_list: {
                animali: 'Animaux autorisés',
                aria_condizionata: 'Climatisation',
                catene_da_neve: 'Chaînes à neige',
                fumatori: 'Fumeurs',
                guida_disabili: 'Conduite pour personnes handicapées',
                lettore_cd: 'Lecteur CD',
                navigatore: 'Navigateur',
                permesso_ztl: 'Permis ZTL',
                pneumatici_invernali: 'Pneus hiver',
                porta_bici: 'Porte-vélos',
                porta_pacchi: 'Porte-paquets',
                porta_sci: 'Porte-ski',
                porta_usb: 'Porte USB',
                seggiolino_bambini: 'Siège enfant',
                sensori_parcheggio: 'Capteurs de stationnement',
                luci_xeno: 'Lumières Xeno',
                cruise_control: 'Régulateur de vitesse'
            },
            conditions_list: {
                animali: 'Animaux NON autorisés',
                fumatori: 'Interdiction de fumer',
            },
            promo_box: {
                title: 'PROMOTION SPÉCIALE',
                description: 'PROTECTION COMPLÈTE à seulement +6€/jour !\nCliquez sur continuer pour choisir comment protéger votre voyage.'
            },
            protection_by_pro_owner: 'Assurance fournie par le Owner Professionnel',
            invalid_promo_code: 'Code promo non valide',
            connect_claim: 'Ouvrez cette voiture via l\'application. Aucune interaction humaine requise.',
        },
        search: {
            page_title: 'Recherchez la voiture dont vous avez besoin',
            cars_available: 'voitures disponibles',
            cars_found: 'voitures trouvées',
            searching_vehicles: 'Recherche de véhicules...',
            search_error: 'Erreur dans la recherche',
            loading_error: 'Erreur lors du chargement des véhicules',
            no_vehicles_found: 'Aucun véhicule trouvé pour les critères de recherche sélectionnés. Essayez de modifier les dates ou les filtres, ou d\'étendre votre recherche à des lieux à proximité.',
            refresh_search: 'Actualiser la recherche',
            sort_by: 'Trier par',
            verified: 'Vérifié',
            trips: 'voyages',
            per_day: 'jour',
            total: 'total',
            why_convenient: 'Pourquoi est-ce avantageux?',
            no_reviews: 'Aucun avis',
            new_vehicle: 'Nouveau véhicule',
            update_search: 'Mettez à jour votre recherche',
            seats: 'places',
            included: 'inclus',
            locate_on_map: 'Afficher sur la carte',
            sorting: {
                relevance: 'Pertinence',
                price: 'Prix',
                distance: 'Distance'
            },
            transmission: {
                manual: 'Manuelle',
                automatic: 'Automatique'
            },
            filters: {
                title: 'Filtres',
                type: 'Type',
                price_range: 'Gamme de prix',
                auting_connect: 'Auting Connect',
                super_owner: 'Super Owner',
                super_owner_only: 'Seulement les Super Owners',
                super_owner_desc: 'Les Super Owners sont des Owners professionnels experts en...',
                all_owners: 'Tous les Owners',
                filter_by_car: 'Filtrer par voiture',
                any_brand: 'Toute marque',
                seats: 'Places',
                doors: 'Portes',
                fuel: 'Carburant',
                gear: 'Transmission',
                categories: {
                    saloon: 'Berline',
                    city_car: 'Citadine',
                    off_road: 'Tout-terrain',
                    station_wagon: 'Break',
                    minivan: 'Monospace',
                    suv: 'SUV'
                },
                connect: {
                    any_desc: 'Avec et sans Auting Connect.',
                    with: 'Avec Auting Connect',
                    with_desc: 'Ouvrez les portes via l\'app. Aucune interaction en personne nécessaire.',
                    without: 'Sans Auting Connect',
                    without_desc: 'Interaction en personne nécessaire lors du début/fin du voyage.'
                },
                fuel_types: {
                    gasoline: 'Essence',
                    diesel: 'Diesel',
                    lpg: 'GPL',
                    methane: 'Méthane',
                    electric: 'Électrique',
                    hybrid: 'Hybride'
                },
                gear_types: {
                    manual: 'Manuelle',
                    automatic: 'Automatique'
                }
            },
            price_info: {
                title: 'Pourquoi est-ce avantageux?',
                premium_includes: 'Le prix PREMIUM comprend:',
                remember: 'Rappel',
                competitor_comparison: 'lors de l\'évaluation du prix, considérez que nos concurrents exigent un dépôt de garantie et des options de responsabilité jusqu\'à €3500.',
                benefits: {
                    free_cancellation: 'Annulation gratuite',
                    reduced_liability: 'Responsabilité réduite pour dommages et vol',
                    roadside_assistance: 'Assistance routière 24/7',
                    no_deposit: '0€ dépôt de garantie'
                }
            },
            premium_box: {
                title: 'Le prix PREMIUM comprend :',
                benefits: {
                    free_cancellation: 'Annulation gratuite',
                    reduced_liability: 'PROMOTION RESPONSABILITÉ ZÉRO en cas de vol et de dommages pour seulement +6€/jour !',
                    roadside_assistance: 'Assistance routière 24h/24 et 7j/7',
                    no_deposit: 'Aucun dépôt de garantie'
                }
            }
        },
        alternatives: {
            page_title: 'Ces propriétaires répondent rapidement',
            page_subtitle: 'Choisissez parmi les propriétaires ayant les meilleurs taux de réponse — et qui disent presque toujours oui. Ne tardez pas : d\'autres conducteurs pourraient les réserver avant vous.',
            banner_title: '{n} voitures sélectionnées pour vous',
            banner_subtitle: 'Nous avons sélectionné ces voitures après avoir examiné vos demandes de réservation.\r\nNous espérons qu\'une d\'entre elles sera parfaite pour vous !\r\nChaque jour, de nouvelles voitures sont ajoutées, alors revenez vérifier si vous ne trouvez pas immédiatement celle qui vous convient.',
            see_all_results: 'Chercher plus de voitures',
        },
        protection: {
            page_title: 'Protection voyage',
            auting_protection: 'Uniquement avec Auting',
            title: 'Profitez pleinement, choisissez la couverture vol/dommages...',
            features: {
                title: 'Déjà inclus dans TOUTES les options :',
                assistance: {
                    title: 'Assistance',
                    desc: 'Assistance routière 24/7'
                },
                liability: {
                    title: 'Options de responsabilité',
                    desc: 'Protégé pour dommages physiques, collision, vol, vandalisme, protection vitres'
                },
                deposit: {
                    title: 'Dépôt de garantie',
                    desc: 'Aucun dépôt de garantie'
                }
            },
            details_prefix: 'Pour les détails des options de limitation de responsabilité,',
            learn_more: 'en savoir plus',
            choose_protection: 'Choisissez la protection vol et dommages',
            promo: 'Promo',
            max_out_of_pocket: 'en cas de sinistre ou vol',
            no_out_of_pocket: 'Aucun frais à votre charge en cas de sinistre ou de vol',
            physical_damage: 'Dommages physiques, collision, vol, vandalisme, protection vitres',
            no_deposit: 'Aucun dépôt de garantie',
            free: 'Gratuit',
            summary_title: 'Vous pourrez procéder au paiement après que le Owner ait accepté la réservation',
            days: 'jours',
            from: 'De',
            to: 'À',
            additional_km: 'Km supplémentaires',
            service_cost: 'Coût du service',
            security_deposit: 'Dépôt de garantie',
            enter_promo_code: 'Entrez le code promo',
            apply: 'Appliquer',
            protection: 'Protection',
            coupon: 'Coupon',
            total: 'Total',
            pricing_error: 'Erreur mise à jour tarifs',
            next: 'Suivant',
            booking_summary: 'Résumé de réservation',
        },
        booking_summary: {
            page_title: 'Résumé de réservation',
            title: 'Résumé de Réservation',
            subtitle: 'Vérifiez les détails de votre réservation avant de confirmer',
            trip_info: 'Info Voyage',
            dates: 'Dates',
            pickup_return: 'Prise en charge et retour',
            trip_saving: 'Économie voyage',
            cancellation: 'Annulation',
            distance_included: 'Distance incluse',
            protection: 'Protection',
            change: 'Changer',
            request_more: 'Demander plus',
            confirm_booking: 'Confirmer',
            free_cancellation: 'Annulation gratuite jusqu\'à 24h avant',
            trip_discount: 'Réduction 3 jours',
            total: 'Total',
            days: 'jours',
            not_specified: 'Non spécifié',
            location_not_available: 'Emplacement non disponible',
            km_included: 'km inclus',
            additional: 'supplémentaires',
            booking_summary: 'Résumé de réservation',
            additional_km: 'Km supplémentaires',
            service_cost: 'Coût du service',
            security_deposit: 'Dépôt de garantie',
            enter_promo_code: 'Entrez le code promo',
            applied: 'Appliqué',
            apply: 'Appliquer',
            promo: 'Promo',
            booking_note: 'Vous ne serez pas débité à ce stade. Le paiement sera traité après l\'approbation du Owner.',
            edit_dates: 'Modifier les dates de réservation',
            message_to_owner: 'Message au Owner',
            your_message: 'Votre message au Owner',
            message_placeholder: 'Écrivez un message au Owner...',
            cancel: 'Annuler',
            sending: 'Envoi...',
            send_request: 'Envoyer la Demande',
            select_additional_km: 'Sélectionner les Kilomètres Supplémentaires',
            default_message: 'Salut! Je suis intéressé à réserver votre {vehicleName} du {startDate} au {endDate}. J\'ai hâte de vous entendre!',
            auth_required: 'Vous devez être authentifié pour compléter la réservation. Voulez-vous vous connecter maintenant?',
            message_required: 'Veuillez écrire un message au Owner',
            data_restored: 'Vos données de réservation ont été restaurées. Vous pouvez continuer avec votre réservation.',
            // authentication_required: 'You must be authenticated to complete the reservation. Do you want to sign in now?'
            authentication_required: 'Vous devez être authentifié pour compléter la réservation. Voulez-vous vous connecter maintenant?',
            login_now: 'Connexion',
            phone_not_verified_error: 'Vous ne pouvez pas effectuer de réservation car vous n\'avez pas encore vérifié votre numéro de téléphone. Accédez à votre profil pour vérifier votre numéro de téléphone.'
        },
        booking_confirmation: {
            page_title: 'Demande envoyée au Owner',
            title: 'Demande envoyée au Owner',
            instruction_1: '1. Le Owner répond généralement en quelques heures.',
            instruction_2: '2. Après que le Owner aura approuvé la demande, vous pourrez procéder au paiement.',
            trip_info: 'Informations du Voyage',
            vehicle_name: 'Nom du Véhicule',
            location_not_available: 'Emplacement non disponible',
            dates: 'Dates',
            not_specified: 'Non spécifié',
            pickup_return: 'Prise en charge et Retour',
            trip_saving: 'Économie du Voyage',
            day_booking: 'jours de réservation',
            cancellation: 'Annulation',
            free_cancellation_until: 'Annulation gratuite jusqu\'au 24h avant le départ',
            distance_included: 'Distance incluse',
            km_included: 'km inclus',
            additional: 'supplémentaires',
            protection: 'Protection',
            homepage: 'Accueil',
            invalid_date: 'Date invalide',
            accepted_title: 'Réservation acceptée !',
            accepted_instruction: 'Votre réservation a été acceptée automatiquement. Vous pouvez maintenant procéder au paiement.',
            owner_message_label: 'Message du propriétaire',
            proceed_to_payment: 'Procéder au paiement',
            suggestions: {
                title: 'Voitures similaires disponibles pour les mêmes dates',
                subtitle: 'Nous avons sélectionné ces voitures <strong>spécialement pour vous</strong>, disponibles aux mêmes dates. Elles appartiennent à des propriétaires qui répondent rapidement.<br/><br/>Nous vous recommandons d\'envoyer une demande, puis de décider de la confirmer ou non, car d\'autres conducteurs pourraient les réserver avant vous.',
                see_all: 'Ou effectuez une nouvelle recherche',
            },
            protection: {
                label: 'Protection',
                minimum_750: 'Minimum 750',
                standard_500: 'Standard 500',
                smart_250: 'Smart 250',
                franchigia_0: 'Franchise 0',
            }
        }
    },
}